var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.shouldHaveSubscription
    ? _c(
        "w-card",
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title")))]),
          _vm.fetching
            ? _c("w-card-content", [_c("w-progress-linear")], 1)
            : _vm.subscription == null
            ? _c("w-card-content", [
                _vm._v(" " + _vm._s(_vm.$ct("no-subscription")) + " "),
              ])
            : _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { staticClass: "item", attrs: { xs: "12", md: "4" } },
                        [
                          _c("div", { staticClass: "header" }, [
                            _vm._v(" " + _vm._s(_vm.$ct("tier")) + " "),
                          ]),
                          _c("div", { staticClass: "content" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$ct(
                                    `common.tiers.${_vm.subscription.plan.tier}`
                                  )
                                ) +
                                " "
                            ),
                          ]),
                          _c("w-spacer"),
                          _c(
                            "div",
                            [
                              _c(
                                "w-link",
                                { attrs: { to: "/account/price" } },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$ct("change-plan")) + " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { staticClass: "item", attrs: { xs: "12", md: "4" } },
                        [
                          _c("div", { staticClass: "header" }, [
                            _vm._v(" " + _vm._s(_vm.$ct("price")) + " "),
                          ]),
                          _c("div", { staticClass: "content" }, [
                            _vm._v(
                              " €" +
                                _vm._s(_vm.subscription.amount) +
                                " / " +
                                _vm._s(_vm.interval) +
                                " "
                            ),
                          ]),
                          _c("w-spacer"),
                          _c(
                            "div",
                            [
                              _c(
                                "w-link",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.openCancelModal()
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s(_vm.$ct("cancel")) + " ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { staticClass: "item", attrs: { xs: "12", md: "4" } },
                        [
                          _c("div", { staticClass: "header" }, [
                            _vm._v(" " + _vm._s(_vm.$ct("next-payment")) + " "),
                          ]),
                          _c("div", { staticClass: "content" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("localDate")(
                                    _vm.subscription.nextPaymentDate
                                  )
                                ) +
                                " "
                            ),
                          ]),
                          _c("w-spacer"),
                          _c(
                            "div",
                            [
                              _vm.showFrequencySwich
                                ? _c(
                                    "w-link",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeInterval()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$ct("change-interval")) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
          _c(
            "w-modal",
            {
              attrs: { "escape-close": "" },
              model: {
                value: _vm.cancelModalOpened,
                callback: function ($$v) {
                  _vm.cancelModalOpened = $$v
                },
                expression: "cancelModalOpened",
              },
            },
            [
              _c(
                "w-card",
                { staticClass: "warning", attrs: { "max-width": "500" } },
                [
                  _c("w-card-title", [
                    _vm._v(_vm._s(_vm.$ct("cancel-confirm.title"))),
                  ]),
                  _c(
                    "w-card-content",
                    [
                      _c(
                        "w-row",
                        [
                          _c("w-col", { attrs: { xs: "12" } }, [
                            _vm._v(
                              " " + _vm._s(_vm.$ct("cancel-confirm.text")) + " "
                            ),
                          ]),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-input", {
                                attrs: {
                                  password: "",
                                  fancy: "",
                                  label: _vm.$ct("cancel-confirm.password"),
                                },
                                model: {
                                  value: _vm.passwordInput,
                                  callback: function ($$v) {
                                    _vm.passwordInput = $$v
                                  },
                                  expression: "passwordInput",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c(
                        "w-button",
                        {
                          staticClass: "cancel",
                          on: {
                            click: function ($event) {
                              return _vm.closeCancelModal()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
                      ),
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          staticClass: "danger",
                          on: {
                            click: function ($event) {
                              return _vm.cancel()
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$ct("cancel-confirm.confirm")) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }